import React from "react";
import Icon, { IconProps } from "./Icon";

/**
 * Lock icon for representing security, authentication, or protected content
 */
export const LockIcon: React.FC<IconProps> = (props) => {
  return (
    <Icon {...props}>
      <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
      <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
    </Icon>
  );
};

export default LockIcon;
